import React, { useEffect } from 'react';
import { Link, NavLink, Outlet, useLocation } from 'react-router-dom';
import logo from '../media/logo.webp';
import './Portfolio.css';

const SITE = 'https://www.sashachisler.com';
export function PageMeta({ title, description, image, type = 'website' }) {
    const { pathname } = useLocation();
    useEffect(() => {
        document.title = title === 'Sasha Chisler' ? title : `${title} — Sasha Chisler`;
        const set = (selector, key, value) => {
            let node = document.head.querySelector(selector);
            if (!node) {
                node = document.createElement('meta');
                node.setAttribute(key, selector.match(/="([^"]+)"/)[1]);
                document.head.appendChild(node);
            }
            node.content = value;
        };
        set('meta[name="description"]', 'name', description || 'Projects and writing by Sasha Chisler.');
        set('meta[property="og:title"]', 'property', document.title);
        set('meta[property="og:description"]', 'property', description || 'Projects and writing by Sasha Chisler.');
        const canonicalPath = pathname.replace(/\/$/, '') || '/';
        set('meta[property="og:url"]', 'property', SITE + canonicalPath);
        set('meta[property="og:type"]', 'property', type);
        set('meta[property="og:image"]', 'property', image ? (image.startsWith('http') ? image : SITE + image) : SITE + '/media/portrait.webp');
        let canonical = document.querySelector('link[rel="canonical"]');
        if (!canonical) {
            canonical = document.createElement('link');
            canonical.rel = 'canonical';
            document.head.appendChild(canonical);
        }
        canonical.href = SITE + canonicalPath;
    }, [title, description, pathname, image, type]);
    return null;
}

export default function SiteLayout() {
    const { pathname, hash } = useLocation();
    const routePath = pathname.replace(/\/$/, '') || '/';
    const isIndex = ['/', '/projects', '/writing'].includes(routePath);
    const sidebarTitle = routePath === '/projects' ? 'Projects' : routePath === '/writing' ? 'Writing' : 'Sasha Chisler';
    const SidebarHeading = isIndex ? 'h1' : 'h2';
    useEffect(() => {
        if (!hash) window.scrollTo(0, 0);
    }, [pathname, hash]);
    return (
        <div className="portfolio">
            <a className="skip-link" href="#main">Skip to content</a>
            <header className="site-header">
                <nav aria-label="Main navigation">
                    <NavLink to="/" end className="nav-signature"><img src={logo} alt="Sasha Chisler" width="2048" height="372" /></NavLink>
                    <span aria-hidden="true">/</span>
                    <NavLink to="/projects">Projects</NavLink>
                    <span aria-hidden="true">/</span>
                    <Link to="/writing" className={routePath === '/writing' || routePath.startsWith('/posts/') ? 'active' : ''} aria-current={routePath === '/writing' || routePath.startsWith('/posts/') ? 'page' : undefined}>Writing</Link>
                </nav>
            </header>
            <div className="site-columns">
                <aside className="identity" aria-label="About Sasha Chisler">
                    <SidebarHeading>{sidebarTitle === 'Sasha Chisler' ? <Link to="/" className="identity-signature"><img src={logo} alt="Sasha Chisler" width="2048" height="372" /></Link> : sidebarTitle}</SidebarHeading>
                    <Link to="/" className="identity-photo" aria-label="About Sasha Chisler"><img src="/media/portrait.webp" alt="Alex Chisler" width="128" height="160" /></Link>
                    <div className="identity-links">
                    <a href="https://www.instagram.com/a.chisler/">Instagram</a>
                    <a href="https://www.linkedin.com/in/alexander-chisler/">LinkedIn</a>
                    </div>
                </aside>
                <main id="main" tabIndex="-1"><Outlet /></main>
            </div>
        </div>
    );
}
